import PropTypes from "prop-types";

export const QuoteElement = PropTypes.shape({
  element_type: PropTypes.string.isRequired,
  amount_pretax: PropTypes.number.isRequired,
  amount_withtax: PropTypes.number.isRequired,
});
